import * as yup from 'yup';
import isURL from 'validator/lib/isURL';

export type IFormInputs = yup.InferType<ReturnType<typeof generateSchema>>;

/*
 * Generate the code schema.
 * This schema is used to validate the code form fields
 */
export const generateSchema = () => {
  const { object, string } = yup;

  return object({
    // Communication purpose
    communicationPurpose: string().required(),

    // Subcategory
    subcategory: string().required(),

    // Code settings
    freeText: string()
      .required('label.requiredText')
      .test(
        'no-url-validation',
        'page.createCode.messages.form.urlNotAllowed',
        (value) => {
          if (!value) return true;

          const words = value.split(/\s+/);

          for (const word of words) {
            if (
              isURL(word, {
                protocols: ['http', 'https'],
                require_protocol: false,
                require_valid_protocol: true,
                allow_underscores: true,
                allow_trailing_dot: false,
                allow_protocol_relative_urls: false,
              })
            ) {
              return false;
            }
          }

          return true;
        }
      ),
  });
};
